import {useIntl} from 'react-intl';

import {CloseIcon} from '../../../icons/close';

import {FilePreviewAction} from './file-preview-action';

type Props = {
    onClick?: () => void;
};
export const FilePreviewActionClose = ({onClick}: Props) => {
    const intl = useIntl();
    const tooltip = intl.formatMessage({id: 'full_screen_modal.close', defaultMessage: 'Close'});

    return (
        <FilePreviewAction onClick={onClick} tooltip={tooltip} aria-label={tooltip}>
            <CloseIcon width={14} height={14} />
        </FilePreviewAction>
    );
};
